
import { filterStateType, modalStateType, objType, pageStateType } from '../types'

export const pages = ['content', 'links', 'selfTeaching','puzzles', 'teacherContent', 'myContent' , 'tutorials'/* , 'contact us' */]

export const initialPageState: pageStateType = {
  page:      'Root',
  opacity:   1,
  savedPage: 'content'
}

export const pageStateGroup = {
  page:      'content',
  opacity:   1,
  savedPage: 'content'
}

export const initialFilterState: filterStateType = {
  searchStr:               '',
  groupSearchStr:          '',
  selectedGrades:          '1234567',
  selectedAppTopic:        '',
  selectedAppSubTopic:     '',
  selectedContent:         'bigContentArr',
  appUrl:                  '',
  openGradeGrid:           false,
  openGroupMenu:           false,
  enableGroupSearchButton: false,
  enableGroupLinkButton:   false,
  showAppIntro:            false,
  createTopicArr:          true,
  appLessons:              [] as { [key: string]: any }[]
}

export const initialModalState: modalStateType = {
  modalVariant: 'logOut',
  showModal:    false
}

export const initialteacherUrlState = {
  url:         '',
  showResults: true,
  showScore:   true
}

export const getPlusRequest  = "אני מעוניין בפרטים נוספים לגבי יישומטיקה פלוס.";
export const getGradeRequest = "אני מעוניין בפרטים נוספים לגבי רכישת גישה לכיתות נוספות";




export const whiteList = [
  'shalem1492@gmail.com', 
 // 'raphael.shalem@gmail.com',
  'gali7654@gmail.com',
  '337210462',
  '059751198',
]


export const pagesWithMenu = [ 'content', 'puzzles', 'teacherContent', 'myContent' ]

export const dev         = process.env.NODE_ENV === 'development';

const url_string         = window.location.href;
const url                = new URL(url_string);
const str                =  url.href;
const ind                =  url.href.indexOf('?app=');
const afterAppParam      = ind !== -1 ? str.slice(ind + 5) : '';
const rawAppParam        = url.searchParams.get("app") || '';
const [appValueFromParam, legacyExtraFromApp] = rawAppParam.split('?');

export const groupUrl    = url.searchParams.get("group");
export const initialLang = url.searchParams.get("lang");
export const showData    = url.searchParams.get("show_data");

export const videoPage   = appValueFromParam || rawAppParam || localStorage.getItem('videoPage') || '';
const deepLinkPuzzleParam =
  url.searchParams.get('pid') ||
  url.searchParams.get('puzzle_id') ||
  url.searchParams.get('puzzleId') ||
  '';

const deepLinkTeacherParam =
  url.searchParams.get('teacher_uid') ||
  url.searchParams.get('teacherUid') ||
  '';

const deepLinkWorksheetParam =
  url.searchParams.get('worksheet_id') ||
  url.searchParams.get('worksheetId') ||
  '';

export const deepLinkExtraParam =
  deepLinkPuzzleParam ||
  deepLinkTeacherParam ||
  deepLinkWorksheetParam ||
  url.searchParams.get('extra') ||
  '';
const legacyExtraFromHref =
  legacyExtraFromApp ||
  (afterAppParam && afterAppParam.includes('?') ? afterAppParam.split('?')[1] : '');
export const exraUrl     = deepLinkExtraParam || legacyExtraFromHref || '';
export const deepLinkView   = url.searchParams.get('view') || '';
const explicitOrigin        = url.searchParams.get('origin') || '';
export const deepLinkOrigin = explicitOrigin ||
  (deepLinkPuzzleParam ? 'puzzles' : '') ||
  (deepLinkTeacherParam ? 'teacherLessons' : '') ||
  (deepLinkWorksheetParam ? 'lessons' : '');
export const deepLinkTarget = videoPage || exraUrl || '';



export const stage       = url.href.includes('https://www.yisumatica.org.il/stage') || url.href.includes('https://www.stage.yisumatica.org.il')


type appVersionType = 'router' | 'noRouter';

export const appVersion: appVersionType = 'router';

export const pagesWithGrid = ['content', 'teacherContent', 'myContent', 'puzzles', 'app page']


export const generalContent = ['bigContentArr', 'apps', 'lessons', 'interaction'];

export const teacherContent = ['allTeacherContent', 'teacherLessons', 'mivdakim'];//

export const navbarDropdowns = ['links', 'selfTeaching']


export const videoTutorials: objType  = {
  puzzles:        'pjcqMENCAF8',
  teacherContent: 'LQJS65rdcxU',
  linksVideo:     'gm4Fa3ksH3o',
  selfTeachVideo: 'ZVoagyo9f3Q'
}


export const freeAccess      = true;

export const chatWithZvi     = true;


//export const navBarSize = 82;

//export const appVersion: appVersionType = 'noRouter';

const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

export const device = getDeviceType();

  